import React from 'react';
import MarkerPrice from './component';

export default React.memo(MarkerPrice);
